<!-- 
Bulk Upload 
-->

<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>
<div class="container-fluid v4-bg-img">
  <div class="container mb-5 min-vh-100">
    <h1 class="v4-color-white text-center">
      {{ "Choose a file" | translator }}
    </h1>
    <br /><br />
    <!-- <input class="form-control" type="file" class="upload" (change)="changeListener($event)" accept=".csv,.xlsx" /> -->

    <div
      [hidden]="missing_entities.length != 0 || data.length > 0"
      class="custom-file"
    >
      <p class="upload-text v4-color-white">
        {{ "Choose the Excel file you want to download" | translator }}
      </p>
      <input
        type="file"
        class="custom-file-input"
        id="customFile"
        (change)="changeListener($event)"
        accept=".csv, .xlsx"
      />
      <label class="custom-file-label" for="customFile">{{
        "Choose a file" | translator
      }}</label>
    </div>



    <div class="text-center">

    
      <!-- Download link -->
      <!-- Download button with tooltip -->
      <div class="download-link">
          <p-button (onClick)="tempdialog = true"
          pTooltip="{{
            'Add the Excel file to download the data' | translator
          }}"
          tooltipPosition="bottom"
          >{{ "Download template" | translator }}</p-button>

          <p-dialog [header]="translate('Download template')" [modal]="true" [(visible)]="tempdialog" [style]="{ width: '25rem' }">
              <div class="flex align-items-center gap-3 mb-3" *ngFor="let item of dataTypes">
                  <p-button [icon]="item.icon" [label]="item.arabic" (onClick)="downloadTemplate(item)"></p-button>
              </div>
          </p-dialog>
      </div>

      <p class="upload-text v4-color-white">
        {{ "You can use Scratch to upload data" | translator }}
      </p>
    </div>

    <div>

      <div class="d-flex justify-content-center">
        <app-skelitions
          [hidden]="!skelition"
          [value]="2"
          class="mb-2"
          style="width: 500px"
        ></app-skelitions>

        <p-table [value]="data_draft" [hidden]="skelition">
          <ng-template pTemplate="header">
            <tr class="custom-th">
              <td colspan="4" class="text-center custom-th-td">
                {{ "Draft" | translator }}
              </td>
            </tr>
            <br />
            <tr>
              <th class="text-center">{{ "Template title" | translator }}</th>
              <th class="text-center">{{ "before" | translator }}</th>
              <th class="text-center">{{ "the date" | translator }}</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-draft>
            <tr>
              <td>{{ draft.object.name }}</td>
              <td>{{ draft.user.user }}</td>
              <td>{{ draft.createdAt | date }}</td>
              <td>
                <button
                  (click)="selectItem(draft.object.data)"
                  class="bulk-btn m-1"
                >
                  <i class="pi pi-check"></i>
                </button>

                <button (click)="deleteItem(draft._id)" class="bulk-btn m-1">
                  <i class="pi pi-trash color-red"></i>
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div [hidden]="missing_entities.length == 0">
      <h1 class="text-center v4-color-white">{{ "Entities" | translator }}</h1>

      <p-table
        [value]="missing_entities"
        [paginator]="false"
        class="p-table-dark"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ "Named" | translator }}</th>
            <th>{{ "Sublevel" | translator }}</th>
            <th>{{ "Basic level" | translator }}</th>
            <th>
              <p-button
                icon="pi pi-check"
                label="{{ 'Add all' | translator }}"
                (click)="AddAllDialogShow()"
              ></p-button>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              {{ item.name }}
              <p-button
                icon="pi pi-angle-down"
                (click)="changeName(item.name, item.parent)"
              ></p-button>
            </td>
            <td>
              {{ item.parent }}
              <p-button
                [hidden]="!item.parent"
                (click)="changeName(item.parent, item.grandparent)"
                icon="pi pi-angle-down"
              ></p-button>
            </td>
            <td>
              {{ item.grandparent }}
              <p-button
                [hidden]="!item.grandparent"
                (click)="changeName(item.grandparent, null)"
                icon="pi pi-angle-down"
              ></p-button>
            </td>
            <td>
              <p-button
                (click)="showDialog(item.name, item.parent, item.grandparent)"
                icon="pi pi-external-link"
                label="{{ 'Adding an organizational unit' | translator }}"
              ></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      id="ouNameChange"
      header="{{ 'Confirmation of change' | translator }}"
      [(visible)]="changedialog"
      [style]="{ width: '50%', minWidth: '300px', maxWidth: '500px' }"
    >
      <div class="p-grid p-nogutter p-fluid">
        <div class="col-12 mb-2">
          <div class="p-field">
            <label for="afterChange">
              {{
                "Do you want to change the organizational unit?" | translator
              }}
              <br />
              ({{ beforeparent }} > {{ beforchange }})
            </label>
            <p-dropdown
              [options]="changeOptions"
              [filter]="true"
              optionLabel="name"
              [(ngModel)]="afterchange"
              placeholder="{{
                'Determine the organizational unit' | translator
              }}"
              appendTo="body"
            ></p-dropdown>
          </div>
        </div>
        <div class="col-12 p-md-6 mb-2">
          <button
            pButton
            icon="pi pi-check"
            label="{{ 'OK' | translator }}"
            class="p-button-success p-button-outlined"
            [disabled]="!afterchange || changeOptions.length === 0"
            (click)="commitchange(beforchange, afterchange, beforeparent)"
          ></button>
        </div>
        <div class="col-12 p-md-6 mb-2">
          <button
            pButton
            icon="pi pi-times"
            label="{{ 'cancellation' | translator }}"
            class="p-button-danger p-button-outlined"
            (click)="changedialog = false"
          ></button>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      id="addSingleOu"
      header="{{ 'Adding an organizational unit' | translator }}"
      [(visible)]="visible"
      style="padding-bottom: 30px"
      [style]="{
        width: '80%',
        minWidth: '500px !important',
        maxWidth: '500px',
        minHeight: '60vh'
      }"
    >
      <div class="p-grid p-nogutter p-fluid pb-5 response">
        <div class="col-12 mb-1">
          <div class="p-field">
            <label for="id">{{ "ID" | translator }}</label>
            <input
              type="text"
              pInputText
              disabled="true"
              [(ngModel)]="newOu.id"
              styleClass="w-100"
            />
          </div>
        </div>
        <div class="col-12 mb-1">
          <div class="p-field">
            <label for="name">{{ "Named" | translator }}</label>
            <input
              type="text"
              pInputText
              disabled="true"
              [(ngModel)]="newOu.name"
              styleClass="w-100"
            />
          </div>
        </div>
        <div class="col-12 mb-1">
          <div class="p-field">
            <label for="parent">{{ "Sublevel" | translator }}</label>
            <input
              type="text"
              pInputText
              disabled="true"
              [value]="newOu.parent?.name"
              styleClass="w-100"
            />
          </div>
        </div>
        <div class="col-12 mb-1">
          <div class="p-field">
            <label>{{ "Image/icon" | translator }}</label>
            <p-toggleButton
              [(ngModel)]="ImageRadio"
              onLabel="{{ 'picture' | translator }}"
              offLabel="{{ 'icon' | translator }}"
              [onIcon]="'pi pi-image'"
              offIcon="pi pi-flag"
            ></p-toggleButton>
          </div>
        </div>
        <div class="col-12 mb-1" [hidden]="ImageRadio == true">
          <div class="p-field">
            <label for="image_sq">{{ "Icons" | translator }}</label>
            <p-dropdown
              [options]="iconOptions"
              [filter]="true"
              [(ngModel)]="newOu.image_sq"
              styleClass="w-100"
            >
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon"></i>
                {{ item.label }}
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div class="col-12 mb-1" [hidden]="ImageRadio == false">
          <div class="p-field">
            <label for="image">{{ "Image" | translator }}</label>
            <div class="p-fileupload">
              <div class="p-grid p-nogutter">
                <div class="col-12 p-md-6">
                  <p-fileUpload
                    mode="basic"
                    name="file"
                    [url]="apilink + 'file/ORGANIZATIONAL_UNIT'"
                    [auto]="true"
                    accept="image/*"
                    [maxFileSize]="1000000"
                    (onUpload)="onUpload($event)"
                  ></p-fileUpload>
                </div>
                <div class="col-12 p-md-6">
                  <div class="preview-container d-flex justify-content-center">
                    <img
                      *ngIf="newOu.image"
                      class="img-fluid center-img"
                      [src]="GlobalConstants.staticFilesURL + newOu.image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mb-1">
          <div class="p-field">
            <label for="location">{{ "City" | translator }}</label>
            <p-dropdown
              [options]="locations"
              [filter]="true"
              optionLabel="name"
              [(ngModel)]="newOu.location"
              styleClass="w-100"
            ></p-dropdown>
          </div>
        </div>
        <div class="col-12 mb-1">
          <div class="p-field">
            <label for="category">{{ "Category" | translator }}</label>
            <p-dropdown
              [options]="categories"
              [filter]="true"
              optionLabel="name"
              [(ngModel)]="newOu.category"
              styleClass="w-100"
            ></p-dropdown>
          </div>
        </div>
        <div class="col-12 mb-1">
          <div class="p-field">
            <label for="type">{{ "Type" | translator }}</label>
            <p-dropdown
              [options]="org_types"
              [filter]="true"
              optionLabel="name"
              [(ngModel)]="newOu.type"
              styleClass="w-100"
            ></p-dropdown>
          </div>
        </div>
        <div class="col-12 mb-1">
          <button
            pButton
            label="{{ 'OK' | translator }}"
            class="p-button-success w-100"
            (click)="newOuSubmit()"
          ></button>
        </div>
        <div class="col-12 mb-1">
          <p-progressBar
            [hidden]="
              loadingprogress == 0 || loadingprogressTotal == loadingprogress
            "
            [value]="(loadingprogress / loadingprogressTotal) * 100"
            mode="determinate"
            [showValue]="false"
          ></p-progressBar>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      id="addBulkOu"
      header="{{ 'Adding an organizational unit' | translator }}"
      [(visible)]="AddAllvisible"
      [style]="{
        width: '80%',
        minWidth: '300px',
        maxWidth: '100%',
        minHeight: '80vh'
      }"
    >
      <div class="p-grid p-nogutter row">
        <div class="col-12 p-md-6 col-md-6">
          <div class="table-container">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ "Named" | translator }}</th>
                  <th>{{ "Sublevel" | translator }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of missing_entities; let i = index">
                  <td>{{ maxId + i }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.parent }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-12 p-md-6 col-md-6">
          <div class="p-grid p-nogutter">
            <div class="col-12 mb-1">
              <div class="p-field">
                <label for="ImageRadio">{{ "Image/icon" | translator }}</label>
                <div class="w-100">
                  <p-toggleButton
                    class="w-100"
                    [(ngModel)]="ImageRadio"
                    onLabel="{{ 'picture' | translator }}"
                    offLabel="{{ 'icon' | translator }}"
                    [onIcon]="'pi pi-image'"
                    offIcon="pi pi-flag"
                  ></p-toggleButton>
                </div>
              </div>
            </div>

            <div class="col-12" *ngIf="ImageRadio == false">
              <div class="p-field">
                <label for="icon">{{ "Icons" | translator }}</label>
                <p-dropdown
                  [options]="iconOptions"
                  [filter]="true"
                  [(ngModel)]="newOu.image_sq"
                  styleClass="w-100"
                >
                  <ng-template let-item pTemplate="selectedItem">
                    <i class="{{ item.icon }}"></i> {{ item.label }}
                  </ng-template>
                  <ng-template let-object pTemplate="item">
                    <i class="{{ object.icon }}"></i> {{ object.label }}
                  </ng-template>
                </p-dropdown>
              </div>
            </div>

            <div class="col-12" *ngIf="ImageRadio == true">
              <div class="p-fileupload">
                <div class="p-grid p-nogutter">
                  <div class="col-12 p-md-6">
                    <p-fileUpload
                      [chooseLabel]="'Upload Image'"
                      mode="basic"
                      name="file"
                      [url]="apilink + 'file/ORGANIZATIONAL_UNIT'"
                      [auto]="true"
                      accept="image/*"
                      [maxFileSize]="1000000"
                      (onUpload)="onUpload($event)"
                    ></p-fileUpload>
                  </div>
                  <div class="col-12 p-md-6">
                    <div
                      class="preview-container d-flex justify-content-center"
                    >
                      <img
                        *ngIf="newOu.image"
                        class="img-fluid center-big-img"
                        [src]="GlobalConstants.staticFilesURL + newOu.image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="p-field">
                <label for="location">{{ "City" | translator }}</label>
                <p-dropdown
                  [options]="locations"
                  [filter]="true"
                  optionLabel="name"
                  [(ngModel)]="newOu.location"
                  styleClass="w-100"
                ></p-dropdown>
              </div>
            </div>

            <div class="col-12">
              <div class="p-field">
                <label for="category"> {{ "Category" | translator }}</label>
                <p-dropdown
                  [options]="categories"
                  [filter]="true"
                  optionLabel="name"
                  [(ngModel)]="newOu.category"
                  styleClass="w-100"
                ></p-dropdown>
              </div>
            </div>

            <div class="col-12">
              <div class="p-field">
                <label for="type">{{ "Type" | translator }}</label>
                <p-dropdown
                  [options]="org_types"
                  [filter]="true"
                  optionLabel="name"
                  [(ngModel)]="newOu.type"
                  styleClass="w-100"
                ></p-dropdown>
              </div>
            </div>

            <div class="col-12">
              <p *ngIf="loadingprogress > 0">
                {{ "download" | translator }}
                {{ (loadingprogress / loadingprogressTotal) * 100 }}%
              </p>
              <p>{{ bulkerror }}</p>
            </div>

            <div class="col-12">
              <div class="p-button-container" [hidden]="hideBulkOuButton">
                <button
                  pButton
                  label="{{ 'OK' | translator }}"
                  *ngIf="loadingprogress < loadingprogressTotal; else elseBlock"
                  class="p-button-success mt-2 w-100"
                  (click)="AddAllDialogSubmit()"
                ></button>
                <ng-template #elseBlock>
                  <button
                    pButton
                    label="{{ 'Cancel' | translator }}"
                    class="p-button-danger mt-2 w-100"
                    (click)="AddAllvisible = false"
                  ></button>
                </ng-template>
              </div>
              <div [hidden]="!hideBulkOuButton">
                {{ "Uploading Data" | translator }}
                <p-progressSpinner
                  [style]="{ width: '50px', height: '50px' }"
                ></p-progressSpinner>
              </div>
              {{ maxId + 1 }}
            </div>
          </div>
        </div>
      </div>
    </p-dialog>

    <div
      *ngIf="missing_entities.length == 0 && data.length > 0"
      class="p-d-flex p-flex-column align-items-center"
    >
      <div>
        <p class="upload-text mt-4 text-center v4-color-white">
          {{
            "The uploaded data's categories have been added to the portal. Click on the button below to generate data and identify any missing fields."
              | translator
          }}
        </p>

        <p-button
          label="{{ 'Data generation' | translator }}"
          class="p-mb-4 text-center d-flex justify-content-center"
          (onClick)="generateData()"
        ></p-button>
      </div>

      <div
        class="p-grid p-justify-between justify-content-center"
        *ngIf="data.length > 0"
      >
        <ng-container *ngIf="missing_fields.length > 0">
          <div class="col-12 mt-4">
            <h3 class="text-center">{{ "Missing fields" | translator }}</h3>
            <p class="upload-text text-center">
              The following are the missing fields in the data. You can replace
              them with existing ones or add new ones from the dashboard.
            </p>
            <div
              class="p-d-flex p-flex-row p-gap-2 p-justify-center d-flex justify-content-center"
            >
              <p-button
                *ngFor="let field of missing_fields"
                [label]="field"
                icon="pi pi-plus"
                (onClick)="MissingFields(field)"
              ></p-button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="missing_types.length > 0">
          <div class="col-12 mt-4">
            <h3 class="text-center">{{ "Imperfect species" | translator }}</h3>
            <p class="upload-text text-center">
              {{
                "The following are the missing types in the data. You can replace them with existing ones or add new ones from the dashboard."
                  | translator
              }}
            </p>
            <div
              class="p-d-flex p-flex-row p-gap-2 p-justify-center d-flex justify-content-center"
            >
              <p-button
                *ngFor="let type of missing_types"
                [label]="type"
                icon="pi pi-plus"
                (onClick)="MissingTypes(type)"
              ></p-button>
            </div>
          </div>
        </ng-container>
      </div>

      <div
        class="d-flex justify-content-center"
        *ngIf="
          missing_entities.length == 0 &&
          missing_fields.length == 0 &&
          missing_types.length == 0 &&
          data_items.length > 0
        "
      >
        <p-button
          icon="pi pi-cloud-upload"
          class="p-2"
          label="{{ 'Download all data' | translator }}"
          styleClass="p-button-success"
          (onClick)="
            UploadAllDataVisible = true;
            loadingprogress = 0;
            loadingprogressTotal = data_items.length
          "
        ></p-button>

        <p-button
          icon="pi pi-save"
          label="{{ 'Save as a draft' | translator }}"
          styleClass="p-button-secondary"
          class="p-2"
          (onClick)="SaveDraftVisible = true"
        ></p-button>
      </div>

      <app-bulkview
        *ngIf="data_items.length > 0"
        [data]="data_items"
        (outputData)="updateSharedData($event)"
      ></app-bulkview>
    </div>

    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="Add Missing Field"
      [(visible)]="missingFieldVisible"
    >
      <app-dynamic-form
        *ngIf="missingField_updateQuestions.length > 0"
        [questions]="missingField_updateQuestions"
        (sendData)="missingField_create($event)"
      ></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </p-dialog>

    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'Assignment to another data type' | translator }}"
      [(visible)]="missingTypeVisible"
      [style]="{ 'max-width': '400px', 'min-height': '500px' }"
    >
      <div>
        {{ missingtype }}

        <p-dropdown
          [options]="server_data_types"
          [filter]="true"
          optionLabel="arabic"
          [(ngModel)]="missingtypefix"
          styleClass=" sstarabic w-100"
        >
        </p-dropdown>

        <p-button
          icon="pi pi-check"
          label="{{ 'OK' | translator }}"
          [disabled]="missingtypefix == '' || server_data_types.length == 0"
          (onClick)="missingTypeChange(missingtype, missingtypefix)"
        ></p-button>
      </div>
    </p-dialog>

    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'Save as a draft' | translator }}"
      [(visible)]="SaveDraftVisible"
      [style]="{ 'max-width': '400px' }"
    >
      <div class="p-fluid">
        <div class="mb-3">
          <label for="draftName" class="form-label">{{
            "Draft name" | translator
          }}</label>
          <input
            type="text"
            id="draftName"
            [(ngModel)]="draftName"
            class="form-control"
            placeholder="{{ 'Enter the name of the draft' | translator }}"
          />
        </div>

        <div class="text-center">
          <p-button
            label="{{ 'Save' | translator }}"
            (onClick)="saveDraft()"
          ></p-button>
        </div>

        <div *ngIf="draftSaved" class="text-success text-center mt-2">
          {{ "The draft has been saved successfully." | translator }}
        </div>
      </div>
    </p-dialog>

    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'Download all data' | translator }}"
      [(visible)]="UploadAllDataVisible"
      [style]="{ width: '80%', minWidth: '300px', maxWidth: '600px' }"
    >
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ "Data name" | translator }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of data_items; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ data.name }}</td>
          </tr>
        </tbody>
      </table>

      <ng-template pTemplate="footer">
        <p-progressBar
          [hidden]="
            loadingprogress == 0 || loadingprogressTotal == loadingprogress
          "
          [value]="(loadingprogress / loadingprogressTotal) * 100"
        ></p-progressBar>

        <p-button
          *ngIf="!UploadAllDataVisibleClose"
          icon="pi pi-check"
          (click)="UploadAllData(data_items)"
          label="{{ 'Download all' | translator }}"
          styleClass="p-button-text"
        ></p-button>

        <p-button
          *ngIf="UploadAllDataVisibleClose"
          icon="pi pi-times"
          (click)="UploadAllDataVisible = false"
          label="{{ 'Cancel' | translator }}"
          styleClass="p-button-text"
        ></p-button>
      </ng-template>
    </p-dialog>
  </div>
</div>
<app-footer class="mt-2"></app-footer>
